import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { StoryHook } from './components/StoryHook';
import { Problem } from './components/Problem';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { TargetAudience } from './components/TargetAudience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-navy-900 text-steel-200 font-sans selection:bg-amber-500/30 selection:text-amber-300" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <StoryHook data-id="element-3" />
        <Problem data-id="element-4" />
        <Mechanism data-id="element-5" />
        <WhatYouGet data-id="element-6" />
        <TargetAudience data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <Proof data-id="element-9" />
        <FAQ data-id="element-10" />
        <Offer data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}